import React, { useEffect, useState } from "react";
import { getTripTimetableAPI } from "../api";
import "./BusTimetable.css";
import { FaBus } from "react-icons/fa";

export default function BusTimetable({ bus, onClose }) {
  const [timetable, setTimetable] = useState([]);
  const [days, setDays] = useState([]);

   const formatTime = (time) => {
    if (!time) return "";
    const [hoursStr, minutes] = time.split(":");
    let hours = parseInt(hoursStr, 10);
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; 
    return `${hours}:${minutes} ${ampm}`;
  };

  useEffect(() => {
    if (!bus) return;

    const fetchTimetable = async () => {
      try {
        const { data } = await getTripTimetableAPI(bus.trip_id || bus.id);

        
       const stops = data.stoptimes.map((stopObj) => ({
          stop: stopObj.stop.name,
          time: formatTime(stopObj.arrival_time),
        }));
        setTimetable(stops);

       
        const busDays = [];
        if (data.mon) busDays.push("Mon");
        if (data.tue) busDays.push("Tue");
        if (data.wed) busDays.push("Wed");
        if (data.thu) busDays.push("Thu");
        if (data.fri) busDays.push("Fri");
        if (data.sat) busDays.push("Sat");
        if (data.sun) busDays.push("Sun");

        setDays(busDays);
      } catch (err) {
        console.error("Error fetching timetable:", err);
      }
    };

    fetchTimetable();
  }, [bus]);

  if (!bus) return null;

  const allDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const runsDaily = days.length === 7;

  return (
    <>
     
      <div className="drawer-overlay" onClick={onClose}></div>

      <div className="drawer">
        
        <div className="drawer-header">
          <div className="bus-infoo">
            <h2 className="bus-namee">{bus.bus?.name || bus.name}</h2>
            <p className="bus-numberr">{bus.bus?.number || bus.number}</p>
          </div>

          <div className="bus-dayss">
            {runsDaily ? (
              <span className="day-tag active">Runs Daily</span>
            ) : (
              allDays.map((day, index) => (
                <span
                  key={index}
                  className={`day-tag ${days.includes(day) ? "active" : "inactive"}`}
                >
                  {day}
                </span>
              ))
            )}
          </div>
        </div>

      
        <div className="timetable">
        
          <div className="line"></div>

          {timetable.map((stopObj, index) => (
            <div key={index} className="timeline-item">
              <div className="circle">
                <FaBus className="bus-icon" />
              </div>
              <div className="stop-details">
                <div className="stop-time">{stopObj.time}</div>
                <div className="stop-name">{stopObj.stop}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
